





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class Footer extends Vue {
  currentTime = "";
  icons = [
    {
      name: "twitter",
      icon: "mdi-twitter",
      link: "https://twitter.com/madostaff",
    },
    {
      name: "youtube",
      icon: "mdi-youtube",
      link: "https://www.youtube.com/channel/UCMJhLgUQQl0ZQL23VRlnANw",
    },
    {
      name: "home",
      icon: "mdi-home",
      link: "https://madosoft.net",
    },
  ];
}
